import { render, staticRenderFns } from "./OwnerDocument.vue?vue&type=template&id=7e81fd5a"
import script from "./OwnerDocument.vue?vue&type=script&lang=ts"
export * from "./OwnerDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports